export default __webpack_public_path__ + "static/media/plus_green_icon.6e2d98bc.svg";